export const COMPANY_LOGO_ALT_TEXT = 'Company logo';
export const MAIN_FEED = 'Main Feed';

export const ERROR_FINDING_USER = 'Error finding user';
export const PROFILE_FEED = 'Profile Feed';

export const REWARDS_HEADING = 'Rewards';
export const REWARDS_HEADER_SUBTITLE = 'Redeem your points for rewards here!';

export const POST_BY = 'Post by';
export const POST_NOT_FOUND = 'Post not found';
export const POST_SUBHEADER = 'This post has been deleted or does not exist';
export const COULDNT_FIND_POST = 'We couldn’t find this post';
export const COULDNT_FIND_POST_COMMENT =
  'Head back to the main feed to see more posts.';

export const getMainFeedName = (companyName: string) =>
  `${companyName}'s ${MAIN_FEED}`;

export const NOTEBOOK_HEADER_TITLE = 'Notebook';
export const NOTEBOOK_HEADER_SUBTITLE = 'Manage your notes.';
